import { useState, useEffect } from "react";
import QRCode from "react-qr-code";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaLink, FaEnvelope } from "react-icons/fa";
import ScrollToTop from "../../components/layout/ScrollToTop";
import { getUserCompany, getCompanyOffer, createCompanyOffer, updateCompanyOffer, getCompanyLaunchById, updateCompany, removeCompanyOffer, getUserCompanyFeatures, removeCompanyFeature, companyFeatureMoveDown, companyFeatureMoveUp, addCompanyFeature, getAllIndustries } from "../../utils/api";
import { useParams } from "react-router-dom";
import { IKImage, IKContext, IKUpload } from 'imagekitio-react';
import { refresh } from "../../services/auth.service";
import { ArrowBigDown, ArrowBigUp, Trash2 } from "lucide-react";

const LaunchManage = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const [showShareDialog, setShowShareDialog] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [website, setWebsite] = useState("");
  const [category, setCategory] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [longDescription, setLongDescription] = useState("");
  const [features, setFeatures] = useState("");
  const [targetAudience, setTargetAudience] = useState("");
  const [userCompany, setUserCompany] = useState(null);
  const [loadedCompany, setLoadedCompany] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [offerId, setOfferId] = useState(null);
  const [offerTitle, setOfferTitle] = useState("");
  const [offerDescription, setOfferDescription] = useState("");
  const [offerType, setOfferType] = useState("discount");
  const [offerValue, setOfferValue] = useState("");
  const [offerCode, setOfferCode] = useState("");
  const [offerUrl, setOfferUrl] = useState("");
  const [offerExpiry, setOfferExpiry] = useState("");
  const [offerTerms, setOfferTerms] = useState("");
  const [hasOffer, setHasOffer] = useState(false);
  const [launchData, setLaunchData] = useState(null);
  const [loadedLaunch, setLoadedLaunch] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [featureList, setFeatureList] = useState([]);
  const [featureText, setFeatureText] = useState("");
  const [howToRedeem, setHowToRedeem] = useState("");
  const [industries, setIndustries] = useState([]);
  const [selectedIndustryId, setSelectedIndustryId] = useState(0);
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  const thumbnailUrl = process.env.REACT_APP_BASE_IMAGE_URL + 'companythumbnails/';

  const { id } = useParams(); // Assuming you have a route parameter for the company ID

  const launchPageUrl = "https://leadrpro.com/launch/your-company"; // Replace with actual URL

  // Add analytics data state
  const [analyticsData] = useState({
    impressions: {
      total: 12483,
      trend: "+12.3%",
      isPositive: true
    },
    pageViews: {
      total: 8245,
      trend: "+8.1%",
      isPositive: true
    },
    clicks: {
      total: 3721,
      trend: "-2.4%",
      isPositive: false
    }
  });

  const [launchSteps, setLaunchSteps] = useState([
    { id: 1, title: 'Complete Company Profile', description: 'Add your company details and description', completed: true },
    { id: 2, title: 'Create Special Offer', description: 'Set up your launch promotion', completed: false },
    { id: 3, title: 'Preview Launch Page', description: 'Review how your page will appear to visitors', completed: false },
    { id: 4, title: 'Share Launch Page', description: 'Start promoting your launch', completed: false }
  ]);

  const [showSuccessBanner, setShowSuccessBanner] = useState(false);

  const getCountdownLabel = () => {
    if (!launchData?.launch_date_start || !launchData?.launch_date_end) return '';

    const now = new Date();
    const startDate = new Date(launchData.launch_date_start);
    const endDate = new Date(launchData.launch_date_end);

    if (now < startDate) {
      return {
        label: "Launch starts in",
        time: Math.ceil((startDate - now) / (1000 * 60 * 60 * 24)) + " days"
      };
    } else if (now < endDate) {
      return {
        label: "Launch ends in",
        time: Math.ceil((endDate - now) / (1000 * 60 * 60 * 24)) + " days"
      };
    } else {
      return {
        label: "Launch ended",
        time: "Completed"
      };
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const offset = date.getTimezoneOffset();
    const adjustedDate = new Date(date.getTime() + offset * 60 * 1000);
    return adjustedDate.toLocaleDateString();
  };

   async function loadIndustries(){
        let data = await getAllIndustries();
  
        if (data.success){
          setIndustries(data.data);
        }
      }

  async function loadFeatures() {
    let res = await getUserCompanyFeatures();

    if (res.success) {
      setFeatureList(res.data);
    }

    else if (res.status === 403) {
      await refresh();

      let res = await getUserCompanyFeatures();

      if (res.success) {
        setFeatureList(res.data);
      }
    }
  }

  useEffect(() => {
    async function loadFeatures() {
      let res = await getUserCompanyFeatures();

      if (res.success) {
        setFeatureList(res.data);
      }

      else if (res.status === 403) {
        await refresh();

        let res = await getUserCompanyFeatures();

        if (res.success) {
          setFeatureList(res.data);
        }
      }
    }

    async function fetchCompanyLaunchData() {
      try {
        const res = await getCompanyLaunchById(id);
        if (res.success) {
          setLaunchData(res.data);
          setLoadedLaunch(true);
        }
      } catch (error) {
        console.error("Error fetching launch data:", error);
      }
    }

    const fetchCompanyData = async () => {
      try {
        const response = await getUserCompany();
        if (response.success) {
          setUserCompany(response.data);
          setCompanyName(response.data.name || "");
          setWebsite(response.data.website || "");
          setCategory(response.data.category || "");
          setShortDescription(response.data.tagline || "");
          setLongDescription(response.data.description || "");
          setFeatures(response.data.unique_value_proposition || "");
          setTargetAudience(response.data.ideal_customer_profile || "");
          setSelectedIndustryId(response.data.industry_id || 0);
          setLoadedCompany(true);
        }
      } catch (error) {
        console.error("Error fetching company data:", error);
      }
    };

    const fetchOfferData = async () => {
      try {
        let res = await getCompanyOffer();
        if (res.success && res.data != null && res.data.length > 0) {
          let row = res.data[0];
          setOfferId(row.company_offer_id || null);
          setOfferTitle(row.title || "");
          setOfferDescription(row.description || "");
          setOfferType(row.offer_type || "discount");
          setOfferValue(row.offer_value || "");
          setOfferCode(row.offer_code || "");
          setOfferUrl(row.offer_url || "");
          setOfferExpiry(row.expires_on || "");
          setOfferTerms(row.terms_and_conditions || "");
          setHowToRedeem(row.how_to_redeem || "");
          setHasOffer(true);
        }
      } catch (error) {
        console.error("Error fetching offer data:", error);
      }
    }

    const loadAllData = async () => {
      setIsLoading(true);
      await Promise.all([
        fetchCompanyLaunchData(),
        fetchCompanyData(),
        fetchOfferData()
      ]);
      setIsLoading(false);
    };

    loadAllData();
    loadFeatures();
    loadIndustries();
  }, []);

  useEffect(() => {
    if (hasOffer) {
      setLaunchSteps(steps => steps.map(step =>
        step.id === 2 ? { ...step, completed: true } : step
      ));
    }
  }, [hasOffer]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(`https://www.leadrpro.com/company/${userCompany?.company_id}/launch`);
    // You might want to add a toast notification here
  };

  const handleSubmitOffer = async (e) => {
    e.preventDefault();
    // Handle form submission
    let res = await createCompanyOffer(offerTitle, offerDescription, offerType, offerValue, offerCode, offerUrl, offerExpiry, offerTerms, howToRedeem);

    if (res.success) {
      setHasOffer(true);
    }

    else {
      alert('error');
    }
  };

  const handleUpdateOffer = async (e) => {
    e.preventDefault();

    let res = await updateCompanyOffer(offerTitle, offerDescription, offerType, offerValue, offerCode, offerUrl, offerExpiry, offerTerms, howToRedeem);

    if (res.success) {
      setShowSuccessBanner(true);
      // Hide the banner after 3 seconds
      setTimeout(() => {
        setShowSuccessBanner(false);
      }, 3000);
    } else {
      alert('error');
    }
  };

  const handleRemoveOffer = async () => {
    if (window.confirm('Are you sure you want to remove this offer? This action cannot be undone.')) {
      let res = await removeCompanyOffer(offerId);
      if (res.success) {
        setHasOffer(false);
        setOfferTitle("");
        setOfferDescription("");
        setOfferType("discount");
        setOfferValue("");
        setOfferCode("");
        setOfferUrl("");
        setOfferExpiry("");
        setOfferTerms("");

        // Update launch steps
        setLaunchSteps(steps => steps.map(step =>
          step.id === 2 ? { ...step, completed: false } : step
        ));
      } else {
        alert('Error removing offer');
      }
    }
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setIsUpdating(true);
    try {
      let res = await updateCompany({ website: website, name: companyName, tagline: shortDescription, description: longDescription, unique_value_proposition: features, ideal_customer_profile: targetAudience, industry_id: selectedIndustryId });
      if (res.success) {
        setShowSuccessBanner(true);
        // Hide the banner after 3 seconds
        setTimeout(() => {
          setShowSuccessBanner(false);
        }, 3000);
      }

      // Simulate API call with timeout
      await new Promise(resolve => setTimeout(resolve, 1000));
      console.log({
        companyName,
        website,
        category,
        shortDescription,
        longDescription,
        features,
        targetAudience
      });

    } catch (error) {
      console.error('Error updating profile:', error);
    } finally {
      setIsUpdating(false);
    }
  };

  async function handleSaveLogo(fileName) {

    if (fileName.length > 0) {
      let res = await updateCompany({ logo: fileName });

      if (res.success) {
        // loadSaveBanner();
        //await hRefreshToken();
        //window.location = window.location;
      }

      else if (res.status === 403) {
        await refresh();

        let res = await updateCompany({ logo: fileName });

        if (res.success) {
          //loadSaveBanner();
          //  await hRefreshToken();
          //window.location = window.location;
        }
      }
    }
  }

  async function onLogoError(error) {
    console.error("Error uploading logo:", error);
  }

  async function onLogoSuccess(response) {
    console.log("Logo uploaded successfully:", response);
    setUserCompany(prev => ({ ...prev, logo: response.name }));
    await handleSaveLogo(response.name);
    // Optionally, you can update the company profile with the new logo URL here  
  }

  async function handleSaveBanner(fileName) {
    if (fileName.length > 0) {
      let res = await updateCompany({ thumbnail_image: fileName });
      if (res.success) {
        setShowSuccessBanner(true);
        setTimeout(() => {
          setShowSuccessBanner(false);
        }, 3000);
      } else if (res.status === 403) {
        await refresh();
        res = await updateCompany({ thumbnail_image: fileName });
        if (res.success) {
          setShowSuccessBanner(true);
          setTimeout(() => {
            setShowSuccessBanner(false);
          }, 3000);
        }
      }
    }
  }

  async function onBannerError(error) {
    console.error("Error uploading banner:", error);
  }

  async function onBannerSuccess(response) {
    console.log("Banner uploaded successfully:", response);
    setUserCompany(prev => ({ ...prev, thumbnail_image: response.name }));
    await handleSaveBanner(response.name);
  }

  async function handleRemoveFeature(id) {
    let res = await removeCompanyFeature(id);

    if (res.success) {
      loadFeatures();
    }

    else if (res.status == 403) {
      await refresh();

      let res = await removeCompanyFeature(id);

      if (res.success) {
        loadFeatures();
      }
    }
  }

  async function moveUpFeature(company_feature_id, index) {
    let prev = features[index - 1];
    let res = await companyFeatureMoveUp(company_feature_id, prev.company_feature_id, index);

    if (res.success) {
      //await getCompany();
      loadFeatures();
      //loadSaveBanner();
    }

    else if (res.status === 403) {
      await refresh();

      let res = await companyFeatureMoveUp(company_feature_id, prev.company_feature_id, index);

      if (res.success) {
        loadFeatures();
        //  loadSaveBanner();
      }
    }
  }

  async function moveDownFeature(company_feature_id, index) {
    let next = features[index + 1];
    let res = await companyFeatureMoveDown(company_feature_id, next.company_feature_id, index);

    if (res.success) {
      loadFeatures();
      // loadSaveBanner();
    }

    else if (res.status === 403) {
      await refresh();
      let res = await companyFeatureMoveDown(company_feature_id, next.company_feature_id, index);

      if (res.success) {
        loadFeatures();
        // loadSaveBanner();
      }
    }
  }

  async function handleAddFeature() {
    if (featureText.length == 0){
      return;
    }

    let res = await addCompanyFeature(featureText);

    if (res.success) {
      setFeatureText('');
      loadFeatures();
    }

    else if (res.status === 403) {
      await refresh();

      let res = await addCompanyFeature(featureText);

      if (res.success) {
        setFeatureText('');
        loadFeatures();
      }
    }
  }

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="flex flex-col items-center space-y-4">
          <div className="w-12 h-12 border-4 border-purple-200 rounded-full animate-spin">
            <div className="w-full h-full border-4 border-purple-600 rounded-full border-t-transparent"></div>
          </div>
          <p className="text-gray-600">Loading your dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <ScrollToTop />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Launch Dashboard</h1>
            <p className="text-gray-600">
              Manage your company profile and track your launch performance
            </p>
          </div>

          {/* <div className="flex space-x-3">
            <button className="px-4 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-50">
              Preview Public Page
            </button>
            <button
              onClick={() => setShowShareDialog(true)}
              className="px-4 py-2 text-sm text-white bg-purple-600 rounded-md hover:bg-purple-700"
            >
              Share Launch Page
            </button>
          </div> */}

        </div>

        {/* <div className="bg-white rounded-lg shadow mb-6 p-4">
          <div className="flex items-center justify-between">
            <div className="flex flex-col space-y-2">
              <div className="flex items-center">
                <div className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm font-medium mr-3">
                  {launchData?.name}
                </div>
              </div>
              <div className="text-sm text-gray-600">
                Launch Period: {new Date(launchData?.launch_date_start).toLocaleDateString()} - {new Date(launchData?.launch_date_end).toLocaleDateString()}
              </div>
            </div>

            <div className="text-right">
              <p className="text-sm text-gray-500">{getCountdownLabel().label}</p>
              <p className="text-xl font-bold">{getCountdownLabel().time}</p>
            </div>
          </div>
        </div> */}

        <div className="space-y-4">
          <div className="border-b border-gray-200">
            <nav className="flex -mb-px space-x-8">
              {["overview", "company-profile", "create-offer"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === tab
                    ? "border-purple-600 text-purple-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }`}
                >
                  {tab.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                </button>
              ))}
            </nav>
          </div>

          <div className="pt-4">
            {activeTab === "overview" && (
              <div className="space-y-8">
                {/* Add launch ready banner */}

                {hasOffer && loadedCompany && launchData.launch_status == 'Running' && (
                  <div className="bg-gradient-to-r from-emerald-500 to-teal-600 rounded-lg shadow-lg p-6 text-white">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-4">
                        <div className="bg-white/20 rounded-full p-3">
                          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                        </div>
                        <div>
                          <h3 className="text-lg font-semibold">Your Launch is Ready! 🚀</h3>
                          <p className="text-emerald-100">Your company profile is complete and your offer is set up. You're all set to start promoting!</p>
                        </div>
                      </div>
                      <button 
                        onClick={() => setShowShareDialog(true)}
                        className="px-4 py-2 bg-white text-emerald-600 rounded-md hover:bg-emerald-50 transition-colors font-medium text-sm flex items-center space-x-2"
                      >
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z" />
                        </svg>
                        <span>Share Your Launch</span>
                      </button>
                    </div>
                  </div>
                )}

                {launchData.launch_status === 'Completed' && (
                  <div className="bg-gradient-to-r from-blue-500 to-indigo-600 rounded-lg shadow-lg p-6 text-white">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-4">
                        <div className="bg-white/20 rounded-full p-3">
                          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                        <div>
                          <h3 className="text-lg font-semibold">Launch Complete! 🎉</h3>
                          <p className="text-blue-100">Your product launch has been completed. Check out your performance metrics below.</p>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                )}

                {/* Add banner if no offer exists */}
                {!hasOffer && (
                  <div className="bg-gradient-to-r from-yellow-50 to-orange-50 border border-yellow-200 rounded-lg p-6">
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 bg-yellow-100 rounded-full p-2">
                        <svg className="w-6 h-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                      </div>
                      <div>
                        <h4 className="text-lg font-semibold text-yellow-800">Add an Offer</h4>
                        <p className="text-sm text-yellow-700 mt-1">
                          Companies that create special launch offers typically see 3x more engagement. Add an exclusive deal to attract more potential customers!
                        </p>
                        <button
                          onClick={() => setActiveTab('create-offer')}
                          className="mt-3 inline-flex items-center text-sm font-medium text-yellow-800 hover:text-yellow-900"
                        >
                          Create Offer <span aria-hidden="true">&rarr;</span>
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {/* Launch Info Section */}
                <div className="bg-white rounded-lg shadow-sm border p-6">
                  <div className="grid md:grid-cols-3 gap-6">
                    <div className="md:col-span-2">
                      <h3 className="text-xl font-semibold text-gray-900 mb-2">Your Product Launch</h3>
                      <p className="text-gray-600 mb-4">
                        Get ready to showcase your product to the world! Your launch period is set and we're here to help you make it successful.
                        Complete all the steps below to ensure maximum impact.
                      </p>
                      <div className="flex flex-wrap gap-4">
                        <div className="flex items-center gap-2">
                          <span className="text-sm text-gray-500">Week:</span>
                          <span className="font-medium">{launchData.name}</span>
                        </div>

                        <div className="flex items-center gap-2">
                          <span className="text-sm text-gray-500">Start Date:</span>
                          <span className="font-medium">{formatDate(launchData?.launch_date_start)}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-sm text-gray-500">End Date:</span>
                          <span className="font-medium">{formatDate(launchData?.launch_date_end)}</span>
                        </div>
                      </div>
                    </div>

                    <div className="bg-purple-50 rounded-lg p-4 flex flex-col justify-center items-center">
                      <p className="text-sm text-purple-600 mb-1">{getCountdownLabel().label}</p>
                      <p className="text-3xl font-bold text-purple-700">{getCountdownLabel().time}</p>
                      <p className="text-sm text-purple-600 mt-2">
                        {getCountdownLabel().label === "Launch starts in" ? "until launch begins" :
                          getCountdownLabel().label === "Launch ends in" ? "remaining in launch" : ""}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Launch Progress Section */}
                <div className="bg-gradient-to-r from-purple-600 to-indigo-600 rounded-lg shadow-lg p-6 text-white">
                  <h3 className="text-xl font-semibold mb-4">Launch Checklist</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    {launchSteps.map((step) => (
                      <div key={step.id} className="relative">
                        <div className={`p-4 rounded-lg h-full ${step.completed ? 'bg-white/20' : 'bg-white/10'} backdrop-blur-sm`}>
                          <div className="flex items-center justify-between mb-2">
                            <span className="text-sm font-medium">Step {step.id}</span>

                            {step.completed && (
                              <svg className="h-5 w-5 text-green-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                              </svg>
                            )}
                          </div>
                          <h4 className="font-medium mb-1">{step.title}</h4>
                          <p className="text-sm text-white/80">{step.description}</p>

                          {step.id === 3 && (
                            <button
                              onClick={() => window.open(`/company/${userCompany?.company_id}/preview`, '_blank')}
                              className="mt-3 w-full px-3 py-1.5 bg-white/10 hover:bg-white/20 border border-white/20 rounded-md text-sm font-medium text-white transition-colors flex items-center justify-center gap-2"
                            >
                              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                              </svg>
                              Preview Page
                            </button>
                          )}

                          {step.id === 4 && (
                            <button
                              onClick={() => setShowShareDialog(true)}
                              className="mt-3 w-full px-3 py-1.5 bg-white/10 hover:bg-white/20 border border-white/20 rounded-md text-sm font-medium text-white transition-colors flex items-center justify-center gap-2"
                            >
                              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z" />
                              </svg>
                              Share
                            </button>
                          )}
                        </div>

                        {step.id !== launchSteps.length && (
                          <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-white/30"></div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            )}

            {activeTab === "company-profile" && (
              <div>
                <div className="space-y-4">
                  <h3 className="text-lg font-medium">Company Information</h3>

                  <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Company Logo
                    </label>
                    <div className="flex items-center space-x-4">
                      <div className="w-20 h-20 border-2 border-gray-300 border-dashed rounded-lg flex items-center justify-center">
                        {userCompany?.logo ? (
                          <img
                            src={imageUrl + userCompany.logo}
                            alt="Company logo"
                            className="max-w-full max-h-full object-contain"
                          />
                        ) : (
                          <svg className="w-8 h-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                        )}
                      </div>
                      <div>
                        <IKContext publicKey="public_Nqch/XuW1fN+NARwogG4qD4gizs=" urlEndpoint="https://ik.imagekit.io/ivgrhmd4k" authenticationEndpoint={process.env.REACT_APP_API_BASE_URL + '/imagekit/auth'}>
                          <IKUpload
                            fileName="logo.jpg"
                            tags={["sample-tag1", "sample-tag2"]}
                            customCoordinates={"10,10,10,10"}
                            isPrivateFile={false}
                            useUniqueFileName={true}
                            responseFields={["tags"]}
                            folder={"/companylogos"}
                            onError={onLogoError} onSuccess={onLogoSuccess}
                          />
                        </IKContext>
                        <p className="mt-1 text-sm text-gray-500">PNG, JPG up to 5MB</p>
                      </div>
                    </div>
                  </div>



                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <label htmlFor="companyName" className="block text-sm font-medium text-gray-700">
                        Company Name *
                      </label>
                      <input
                        id="companyName"
                        name="companyName"
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                        placeholder="e.g., LeadrPro"
                        required
                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                      />
                    </div>

                    <div className="space-y-2">
                      <label htmlFor="website" className="block text-sm font-medium text-gray-700">
                        Website *
                      </label>
                      <input
                        id="website"
                        name="website"
                        value={website}
                        onChange={(e) => setWebsite(e.target.value)}
                        placeholder="e.g., https://leadrpro.com"

                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                      />
                    </div>
                  </div>

                  <div className="space-y-2">
                    <label htmlFor="category" className="block text-sm font-medium text-gray-700">
                      Category *
                    </label>

                    <select className='input select' value={selectedIndustryId} onChange={(e) => setSelectedIndustryId(e.target.value)}>
                  <option value="0">Select industry...</option>
                  {industries.map(item => (
                    <>
                      <option value={item.industry_id}>{item.name}</option>
                    </>
                  ))}
                </select>

                    {/* <input
                      id="category"
                      name="category"
                      value={category}
                      rquired
                      onChange={(e) => setCategory(e.target.value)}
                      placeholder="e.g., Marketing, HR, Development, Sales"

                      className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                    /> */}
                  </div>

                  <div className="space-y-2">
                    <label htmlFor="shortDescription" className="block text-sm font-medium text-gray-700">
                      Short Description (50 characters max)
                    </label>
                    <input
                      id="shortDescription"
                      name="shortDescription"
                      value={shortDescription}
                      onChange={(e) => setShortDescription(e.target.value)}
                      placeholder="A brief one-line description of your product"
                      maxLength={50}
                      className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                    />
                  </div>

                  <div className="space-y-2">
                    <label htmlFor="longDescription" className="block text-sm font-medium text-gray-700">
                      Detailed Description
                    </label>
                    <textarea
                      id="longDescription"
                      name="longDescription"
                      value={longDescription}
                      onChange={(e) => setLongDescription(e.target.value)}
                      placeholder="Provide a comprehensive description of your product and what it does"
                      rows={4}
                      className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                    />
                  </div>
                </div>


                <div className="space-y-4">
                  <h3 className="text-lg font-medium">Product Details</h3>

                  <div className="space-y-2">
                    <label htmlFor="features" className="block text-sm font-medium text-gray-700">
                      Key Features *
                    </label>
                    <textarea
                      id="features"
                      name="features"
                      value={features}
                      onChange={(e) => setFeatures(e.target.value)}
                      placeholder="List your product's key features (one per line)"
                      rows={4}

                      className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                    />
                  </div>

                  <div className="space-y-2">
                    <label htmlFor="targetAudience" className="block text-sm font-medium text-gray-700">
                      Target Audience *
                    </label>
                    <textarea
                      id="targetAudience"
                      name="targetAudience"
                      value={targetAudience}
                      onChange={(e) => setTargetAudience(e.target.value)}
                      placeholder="Describe your ideal customer profile (company size, industry, role)"
                      rows={3}

                      className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                    />
                  </div>
                </div>

                <div className="mt-2 pt-6 border-t border-gray-200">
                  <div className="flex justify-end">
                    <button
                      onClick={handleUpdateProfile}
                      disabled={isUpdating}
                      className="px-6 py-2 text-sm text-white bg-purple-600 rounded-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                    >
                      {isUpdating ? (
                        <>
                          <svg className="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          Updating...
                        </>
                      ) : (
                        'Update Profile'
                      )}
                    </button>
                  </div>
                </div>

                <div className="mb-6">
                  <h3 className="text-lg font-medium">Company Profile</h3>

                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Company Banner Image
                  </label>
                  <div className="flex items-center space-x-4">
                    <div className="w-full border-2 border-gray-300 border-dashed rounded-lg flex items-center justify-center bg-gray-50">
                      {userCompany?.thumbnail_image ? (
                        <img
                          src={thumbnailUrl + userCompany.thumbnail_image}
                          alt="Company banner"
                          className="w-full h-full object-cover rounded-lg"
                        />
                      ) : (
                        <div className="text-center">
                          <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                          <p className="mt-1 text-sm text-gray-500">Add a banner image for your company page</p>
                        </div>
                      )}
                    </div>
                    <div>
                      <IKContext publicKey="public_Nqch/XuW1fN+NARwogG4qD4gizs=" urlEndpoint="https://ik.imagekit.io/ivgrhmd4k" authenticationEndpoint={process.env.REACT_APP_API_BASE_URL + '/imagekit/auth'}>
                        <IKUpload
                          fileName="banner.jpg"
                          tags={["banner"]}
                          customCoordinates={"10,10,10,10"}
                          isPrivateFile={false}
                          useUniqueFileName={true}
                          responseFields={["tags"]}
                          folder={"/companythumbnails"}
                          onError={onBannerError}
                          onSuccess={onBannerSuccess}
                        />
                      </IKContext>
                      <p className="mt-1 text-sm text-gray-500">Recommended size: 1200x400px. PNG, JPG up to 5MB</p>
                    </div>
                  </div>
                </div>

                <hr />

                <div className='accountinfo__form-group' id='features'>
                  <div className="profileinfo__form-group-title" style={{ marginBottom: "10px" }}>Features</div>

                  <p className='account__description'>
                    Highlight the main points that make your business stand out.
                  </p>

                  <div className='companyedit__features'>
                    {featureList.length == 0 && (
                      <div style={{ marginBottom: '10px' }}><strong>No features found...</strong></div>
                    )}
                    {featureList && featureList.map((item, index) => (
                      <div className='companyedit__feature'>
                        <div className='companyedit__feature-text'>{item.feature_text}</div>

                        <div className='companyedit__feature-btns'><button className='btn' onClick={() => handleRemoveFeature(item.company_feature_id)}>
                          <Trash2 />
                        </button>

                          {index < featureList.length - 1 && (
                            <button className='btn' onClick={() => moveDownFeature(item.company_feature_id, index)}><ArrowBigDown /> </button>
                          )}

                          {index > 0 && (
                            <button className='btn' onClick={() => moveUpFeature(item.company_feature_id, index)}><ArrowBigUp /></button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div>
                    <input type='text' className='input' value={featureText} onChange={(e) => setFeatureText(e.target.value)} placeholder='Add feature...' />

                    <div style={{ marginTop: '20px' }}>
                      <button className='px-6 py-2 text-sm text-white bg-purple-600 rounded-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 disabled:opacity-50 disabled:cursor-not-allowed flex items-center' onClick={() => handleAddFeature()}>Add feature</button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "create-offer" && (
              <div className="bg-white rounded-lg border shadow-sm">
                {showSuccessBanner && (
                  <div className="bg-green-50 p-4 rounded-t-lg border-b border-green-200">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <div className="ml-3">
                        <p className="text-sm font-medium text-green-800">
                          Changes saved successfully!
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                <div className="p-6 border-b border-gray-200">
                  <h2 className="text-lg font-semibold text-gray-900">Create Launch Offer</h2>
                  <p className="text-sm text-gray-500">Create a special offer for your product launch</p>
                </div>

                <div className="p-6">
                  <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Offer Title</label>
                      <input
                        type="text"
                        name="title"
                        value={offerTitle}
                        onChange={(e) => setOfferTitle(e.target.value)}
                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                        placeholder="e.g., Launch Week Special"
                        required
                      />
                    </div>

                    {/* <div>
                      <label className="block text-sm font-medium text-gray-700">Deal Type</label>
                      <select
                        name="dealType"
                        value={offerType}
                        onChange={(e) => setOfferType(e.target.value)}
                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                      >
                        <option value="discount">Percentage Discount</option>
                        <option value="fixed">Fixed Amount Off</option>
                        <option value="freeTrial">Extended Free Trial</option>
                        <option value="bonus">Bonus Features</option>
                      </select>
                    </div> */}

                    {/* <div>
                      <label className="block text-sm font-medium text-gray-700">Offer Value</label>
                      <div className="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          name="value"
                          value={offerValue}
                          onChange={(e) => setOfferValue(e.target.value)}
                          className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                          placeholder={offerType === 'discount' ? '20' : '100'}
                          required
                        />
                        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                          <span className="text-gray-500 sm:text-sm">
                            {offerType === 'discount' ? '%' : '$'}
                          </span>
                        </div>
                      </div>
                    </div> */}

                    {/* <div>
                        <label className="block text-sm font-medium text-gray-700">Maximum Redemptions</label>
                        <input
                          type="number"
                          name="maxRedemptions"
                          onChange={handleOfferChange}
                          className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                          placeholder="Leave empty for unlimited"
                        />
                      </div> */}

                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Offer Code <span className="text-xs font-medium text-gray-400">* Optional</span></label>
                      <input
                        type="text"
                        name="offerCode"
                        value={offerCode}
                        onChange={(e) => setOfferCode(e.target.value)}
                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                        placeholder="e.g., LAUNCH2024"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Offer URL <span className="text-xs font-medium text-gray-400">* Optional</span></label>
                      <input
                        type="url"
                        name="offerUrl"
                        value={offerUrl}
                        onChange={(e) => setOfferUrl(e.target.value)}
                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                        placeholder="https://example.com/special-offer"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700">Offer Description</label>
                      <textarea
                        name="description"
                        value={offerDescription}
                        onChange={(e) => setOfferDescription(e.target.value)}
                        rows={3}
                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                        placeholder="Describe your offer and its benefits"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700">How to Redeem</label>
                      <textarea
                        name="termsAndConditions"
                        value={howToRedeem}
                        onChange={(e) => setHowToRedeem(e.target.value)}
                        rows={3}
                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                        placeholder="Specify any terms, conditions, or restrictions"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700">Terms and Conditions <span className="text-xs font-medium text-gray-400">* Optional</span></label>
                      <textarea
                        name="termsAndConditions"
                        value={offerTerms}
                        onChange={(e) => setOfferTerms(e.target.value)}
                        rows={3}
                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                        placeholder="Specify any terms, conditions, or restrictions"
                      />
                    </div>
                  </div>

                  <div className="flex justify-end space-x-3 mt-4">
                    {hasOffer && (
                      <>
                        <button
                          type="button"
                          onClick={handleRemoveOffer}
                          className="px-4 py-2 text-sm text-red-600 border border-red-300 rounded-md hover:bg-red-50"
                        >
                          Remove Offer
                        </button>
                        <button
                          type="button"
                          onClick={(e) => handleUpdateOffer(e)}
                          className="px-4 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-50"
                        >
                          Save Changes
                        </button>
                      </>
                    )}

                    {!hasOffer && (
                      <button
                        type="submit"
                        onClick={(e) => handleSubmitOffer(e)}
                        className="px-4 py-2 text-sm text-white bg-purple-600 rounded-md hover:bg-purple-700"
                      >
                        Create Offer
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}

            {activeTab === "competition" && (
              <div className="bg-white rounded-lg border shadow-sm">
                <div className="p-6 border-b border-gray-200">
                  <h2 className="text-lg font-semibold text-gray-900">Weekly Competition Status</h2>
                  <p className="text-sm text-gray-500">Week 26: April 18 - April 24, 2025</p>
                </div>
                <div className="p-6">
                  <div className="space-y-8">
                    {[
                      { rank: 1, name: "Skuad", category: "Human Resources", impressions: 12483, badge: "gold" },
                      { rank: 2, name: "Workato", category: "Integration Platform", impressions: 10245, badge: "silver" },
                      { rank: 3, name: "Retool", category: "Internal Tools", impressions: 9876, badge: "bronze" }
                    ].map((company) => (
                      <div key={company.rank} className="flex items-center justify-between bg-white rounded-lg border p-4">
                        <div className="flex items-center">
                          <div className={`flex items-center justify-center w-8 h-8 rounded-full mr-4 ${company.badge === "gold" ? "bg-yellow-400" :
                            company.badge === "silver" ? "bg-gray-300" : "bg-amber-600"
                            }`}>
                            <span className="font-bold text-lg">{company.rank}</span>
                          </div>
                          <div>
                            <p className="font-medium">{company.name}</p>
                            <p className="text-sm text-gray-600">{company.category}</p>
                          </div>
                        </div>
                        <div className="text-right">
                          <p className="font-medium">{company.impressions.toLocaleString()} impressions</p>
                          <p className="text-sm text-gray-500">
                            {company.rank === 1 ? (
                              <span className="text-green-600">Leading by 2,238 impressions</span>
                            ) : (
                              <span className="text-orange-600">Trailing by {(12483 - company.impressions).toLocaleString()} impressions</span>
                            )}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {activeTab === "settings" && (
              <div className="bg-white rounded-lg border shadow-sm">
                <div className="p-6 border-b border-gray-200">
                  <h2 className="text-lg font-semibold text-gray-900">Account Settings</h2>
                  <p className="text-sm text-gray-500">
                    Manage your account preferences and notification settings
                  </p>
                </div>
                <div className="p-6">
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-lg font-medium mb-4">Email Notifications</h3>
                      <div className="space-y-4">
                        {[
                          {
                            title: "Weekly Performance Report",
                            description: "Receive weekly stats about your launch performance"
                          },
                          {
                            title: "Lead Notifications",
                            description: "Get notified when someone requests information"
                          },
                          {
                            title: "Ranking Changes",
                            description: "Get notified when your ranking changes significantly"
                          }
                        ].map((setting) => (
                          <div key={setting.title} className="flex items-center justify-between">
                            <div>
                              <p className="font-medium">{setting.title}</p>
                              <p className="text-sm text-gray-600">{setting.description}</p>
                            </div>
                            <div className="flex items-center">
                              <input
                                type="checkbox"
                                defaultChecked
                                className="rounded border-gray-300 text-purple-600 focus:ring-purple-500"
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="pt-4">
                      <button className="px-4 py-2 text-sm text-white bg-purple-600 rounded-md hover:bg-purple-700">
                        Save Settings
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>

      {/* Share Dialog */}
      {showShareDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Share Launch Page</h3>
              <button
                onClick={() => setShowShareDialog(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ×
              </button>
            </div>

            <div className="space-y-6">
              {/* Share buttons */}
              {/* <div className="flex justify-center space-x-4">
                {[
                  { icon: FaFacebookF, color: "bg-blue-600", label: "Facebook" },
                  { icon: FaTwitter, color: "bg-sky-500", label: "Twitter" },
                  { icon: FaLinkedinIn, color: "bg-blue-700", label: "LinkedIn" },
                  { icon: FaEnvelope, color: "bg-red-500", label: "Email" },
                ].map((item) => (
                  <button
                    key={item.label}
                    className={`${item.color} p-3 rounded-full text-white hover:opacity-90`}
                  >
                    <item.icon className="w-5 h-5" />
                  </button>
                ))}
              </div> */}

              {/* URL copy section */}
              <div className="flex items-center gap-2 p-2 bg-gray-50 rounded-lg">
                <input
                  type="text"
                  value={`https://www.leadrpro.com/company/${userCompany.company_id}/launch`}
                  readOnly
                  className="flex-1 bg-transparent text-sm border-none focus:ring-0"
                />
                <button
                  onClick={copyToClipboard}
                  className="p-2 text-purple-600 hover:text-purple-700"
                >
                  <FaLink className="w-5 h-5" />
                </button>
              </div>

              {/* QR Code */}
              <div className="flex justify-center p-4">
                <QRCode value={`https://www.leadrpro.com/company/${userCompany.company_id}/launch`} size={150} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LaunchManage;